module.exports = __webpack_public_path__ + "img/finishpic.a88442cf.png";